// DEFINITIVE RUBBER BAND SCROLLING FIX - JavaScript Component

export const initSimpleSafariFix = () => {
  console.log('🚫 Initializing rubber band scrolling prevention...');
  
  // Detect environment
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Add detection classes for CSS targeting
  if (isIOS) document.documentElement.classList.add('ios');
  if (isSafari) document.documentElement.classList.add('safari');
  if (isTouchDevice) document.documentElement.classList.add('touch-device');
  
  // CRITICAL: Apply styles immediately via JavaScript to override everything
  const applyRubberBandFix = () => {
    // Lock the viewport
    document.documentElement.style.setProperty('position', 'fixed', 'important');
    document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    document.documentElement.style.setProperty('width', '100%', 'important');
    document.documentElement.style.setProperty('height', '100%', 'important');
    document.documentElement.style.setProperty('overscroll-behavior', 'none', 'important');
    
    document.body.style.setProperty('position', 'fixed', 'important');
    document.body.style.setProperty('overflow', 'hidden', 'important');
    document.body.style.setProperty('width', '100%', 'important');
    document.body.style.setProperty('height', '100%', 'important');
    document.body.style.setProperty('margin', '0', 'important');
    document.body.style.setProperty('padding', '0', 'important');
    document.body.style.setProperty('overscroll-behavior', 'none', 'important');
    document.body.style.setProperty('overscroll-behavior-y', 'none', 'important');
    document.body.style.setProperty('overscroll-behavior-x', 'none', 'important');
    
    // Make root scrollable
    const root = document.getElementById('root');
    if (root) {
      root.style.setProperty('position', 'fixed', 'important');
      root.style.setProperty('top', '0', 'important');
      root.style.setProperty('left', '0', 'important');
      root.style.setProperty('right', '0', 'important');
      root.style.setProperty('bottom', '0', 'important');
      root.style.setProperty('overflow', 'auto', 'important');
      root.style.setProperty('overscroll-behavior', 'none', 'important');
      root.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      root.style.setProperty('-webkit-transform', 'translateZ(0)', 'important');
    }
    
    console.log('✅ Rubber band fix styles applied via JavaScript');
  };
  
  // Apply immediately
  applyRubberBandFix();
  
  // Apply again when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRubberBandFix);
  }
  
  // CRITICAL: Prevent all touch-based rubber band scrolling
  let isScrolling = false;
  
  document.addEventListener('touchstart', (e) => {
    // Check if touch is on a scrollable element
    const target = e.target.closest('#root, .scrollable, .scroll-container');
    isScrolling = !!target;
  }, { passive: true });
  
  document.addEventListener('touchmove', (e) => {
    // If not scrolling in a designated area, prevent default
    if (!isScrolling) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    
    // Additional check for boundary scrolling
    const scrollableElement = e.target.closest('#root');
    if (scrollableElement) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableElement;
      const isAtTop = scrollTop <= 0;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
      
      // Get touch direction
      const touch = e.touches[0];
      const deltaY = touch.clientY - (touch.startY || touch.clientY);
      
      // Prevent rubber band at boundaries
      if ((isAtTop && deltaY > 0) || (isAtBottom && deltaY < 0)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
  }, { passive: false });
  
  // Prevent window-level bouncing on iOS
  if (isIOS) {
    window.addEventListener('touchmove', (e) => {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    }, { passive: false });
  }
  
  // Fix viewport height for iOS
  const setVH = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  
  setVH();
  window.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', () => {
    setTimeout(setVH, 100); // Delay for orientation change
  });
  
  // Override any conflicting styles that might be applied later
  const observer = new MutationObserver(() => {
    applyRubberBandFix();
  });
  
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  console.log('🚫 Rubber band scrolling DISABLED:', { isIOS, isSafari, isTouchDevice });
}; 